/**************************************************
 * Nombre:       FilaEquipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, AvatarGroup, Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {verificarMembresia} from "../../../CodigoCliente/Funciones/verificarMembresia";
import {usuarioContext} from "../../../App";
import {reducirNombre} from "../../../CodigoCliente/Funciones/reducirNombre";

const FilaEquipo = ({items = [], titulo, porcentaje}) => {
    const cData = useContext(usuarioContext)
    const [membresiaActiva, setMembresiaActivas] = useState(false);

    useEffect(() => {

        setMembresiaActivas(verificarMembresia(cData.usuario))

    }, []);

    if (items.length <= 0) {
        return ''
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 12, md: 1}} sx={{justifyContent: 'flex-start', mt: -2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>{titulo}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{
                            fontSize: 24,
                            fontWeight: 600
                        }}>{`${membresiaActiva ? porcentaje : porcentaje / 2}%`}</Typography>
                    </Grid>

                </Grid>

            </Grid>

            <Grid container size={{xs: 10, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                <AvatarGroup max={4} spacing={10}>
                    {items.map((it, index) => (
                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{maxWidth: 100}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Avatar alt={it.nombre} src={it.img} sx={{width: 52, height: 52}}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0.5}}>
                                <Typography sx={{
                                    fontSize: 14,
                                    textAlign: 'center',
                                    width: 90,
                                    //backgroundColor: 'pink'
                                }}>{reducirNombre({
                                    nombre: it.nombre,
                                    largo: 11,
                                })}</Typography>
                            </Grid>

                        </Grid>


                    ))}
                </AvatarGroup>
            </Grid>


        </Grid>
    )

}
export default FilaEquipo